import { TeachingLocation } from 'types/location'

export const getFromLocalizedString = (
  localizedString: TeachingLocation['name'],
  locale: 'en' | 'fr' = 'en',
  defaultLocale: 'en' | 'fr' = 'en'
) =>
  typeof localizedString === 'string'
    ? localizedString
    : localizedString?.[locale] || localizedString?.[defaultLocale] || '' // Just hardcode for now since this dashboard doesn't support localization
